/** Section headings on Manage Firm stats panels (WSG Overview, Professional Profiles, etc.). */
export const MANAGE_FIRM_STATS_SECTION_TITLE_CLASS =
  "text-lg font-semibold text-gray-font !font-roboto";

/** WSG Overview table metric values (larger than row labels). */
export const MANAGE_FIRM_WSG_OVERVIEW_METRIC_CELL_CLASS =
  "text-center text-lg font-semibold tabular-nums leading-tight text-gray-font md:text-xl";
